import { render, staticRenderFns } from "./BmDialog.vue?vue&type=template&id=51ea5dae&"
import script from "./BmDialog.vue?vue&type=script&lang=js&"
export * from "./BmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports